<template>
<div class="row animated fadeIn">
  <div class="col-md-8 offset-md-2">
    <div class="card ">
      <div class="card-header">
        <i class="fa fa-pencil"></i><strong>Realm</strong>
      </div>
      <div class="card-block">
        <form>
          <div class="form-group input" :class="{'has-danger': errors.has('nome') }">
            <label class="col-form-label">Nome</label>
            <input type="text" class="form-control" name="nome" v-model="model.realm.name" v-validate="'required'">
            <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
          </div>

          <div v-if="!model.realm.id">
            <br/>
            <h6>Administrador</h6>
            <hr />
            <div class="row">
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('userFirstName') }">
                <label class="col-form-label">Nome</label>
                <input type="text" class="form-control" name="userFirstName" v-validate="'required'" v-model="model.user.firstName">
                <span v-show="errors.has('userFirstName')" class="form-control-feedback">{{ errors.first('userFirstName') }}</span>
              </div>
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('sobrenome') }">
                <label class="col-form-label">Sobrenome</label>
                <input type="text" class="form-control" name="sobrenome" v-validate="'required'" v-model="model.user.lastName">
                <span v-show="errors.has('sobrenome')" class="form-control-feedback">{{ errors.first('sobrenome') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('login') }">
                <label class="col-form-label">Login</label>
                <input type="text" class="form-control" name="login" v-validate="'required'" v-model="model.user.username">
                <span v-show="errors.has('login')" class="form-control-feedback">{{ errors.first('login') }}</span>
              </div>
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('email') }">
                <label class="col-form-label">Email</label>
                <input type="text" class="form-control" name="email" v-validate="'required|email'" v-model="model.user.email">
                <span v-show="errors.has('email')" class="form-control-feedback">{{ errors.first('email') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('senha') }">
                <label class="col-form-label">
                  Senha
                </label>
                <input type="password" class="form-control" name="senha" v-validate="'required|confirmed:confirma senha'" v-model="model.user.password">
                <span v-show="errors.has('senha')" class="form-control-feedback">{{ errors.first('senha') }}</span>
              </div>
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('confirma senha') }">
                <label class="col-form-label">Confirma senha</label>
                <input type="password" class="form-control" name="confirma senha">
              </div>
            </div>
          </div>

          <br/>
          <h6>Configurações</h6>
          <hr />
          <b-tabs no-block>
            <b-tab :title="config.name || '...'" v-for="(config, index) in model.configurations" :key="index">
              <fieldset disabled>
                <div class="form-group">
                  <label>Id</label>
                  <input type="text" class="form-control"  v-model="config.id">
                </div>
              </fieldset>
              <fieldset disabled>
                <div class="form-group">
                  <label>Secret</label>
                  <input type="text" class="form-control"  v-model="config.secret">
                </div>
              </fieldset>
              <div class="form-group input" :class="{'has-danger': errors.has('conf_name') }">
                <label class="col-form-label">Nome</label>
                <input type="text" class="form-control" name="conf_name" v-model="config.name" v-validate="'required'" data-vv-as="nome">
                <span v-show="errors.has('conf_name')" class="form-control-feedback">{{ errors.first('conf_name') }}</span>
              </div>
              <br/>
              <h6>Database</h6>
              <hr />
              <div class="form-group select" :class="{'has-danger': errors.has('dbType') }">
                <label class="col-form-label">Tipo</label>
                <select class="form-control" name="dbType" v-validate="'required'" v-model="config.databaseType" @change="changeDBType(config.database)">
                    <option value="database">DATABASE</option>
                    <option value="ldap">LDAP</option>
                  </select>
              </div>

              <template v-if="config.databaseType == 'ldap'">
                  <div class="row">
                    <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('baseDn') }">
                      <label class="col-form-label">Base DN</label>
                      <input type="text" class="form-control" name="baseDn" v-validate="'required'" v-model="config.database.baseDn">
                      <span v-show="errors.has('baseDn')" class="form-control-feedback">{{ errors.first('baseDn') }}</span>
                    </div>
                    <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('filtro') }">
                      <label class="col-form-label">Filtro</label>
                      <input type="text" class="form-control" name="filtro" v-validate="'required'" v-model="config.database.filter">
                      <span v-show="errors.has('filtro')" class="form-control-feedback">{{ errors.first('filtro') }}</span>
                    </div>
                  </div>

                  <div class="form-group input" :class="{'has-danger': errors.has('url') }">
                    <label class="col-form-label">URL</label>
                    <input type="text" class="form-control" name="url" v-validate="'required'" v-model="config.database.url">
                    <span v-show="errors.has('url')" class="form-control-feedback">{{ errors.first('url') }}</span>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('usuario') }">
                      <label class="col-form-label">Usuário</label>
                      <input type="text" class="form-control" name="usuario" v-validate="'required'" v-model="config.database.user">
                      <span v-show="errors.has('usuario')" class="form-control-feedback">{{ errors.first('usuario') }}</span>
                    </div>
                    <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('senha') }">
                      <label class="col-form-label">Senha</label>
                      <input type="password" class="form-control" name="senha" v-validate="'required'" v-model="config.database.password">
                      <span v-show="errors.has('senha')" class="form-control-feedback">{{ errors.first('senha') }}</span>
                    </div>
                  </div>
                </template>

              <div>
                <b-btn size="sm" variant="danger" class="float-right" @click="()=>closeTab(index)">
                  <i class="fa fa-trash"></i>
                </b-btn>
              </div>
            </b-tab>

            <!-- Newtab Button (Using tabs slot) -->
            <b-nav-item slot="tabs" @click.prevent="newTab" href="#">
              <i class="fa fa-plus"></i>
            </b-nav-item>

            <!-- Render this if no tabs -->
            <div slot="empty" class="text-center text-muted">
              Não há aplicações cadastrados
              <br> Abra uma nova aba clicando no botão <i class="fa fa-plus"></i>.
            </div>
          </b-tabs>
        </form>
      </div>
      <div class="card-footer">
        <div class="pull-right">
          <router-link :to="'/mystique/realms'" class="btn btn-sm">
            <i class="fa fa-chevron-left"></i> Cancelar
          </router-link>
          <button type="button" class="btn btn-sm btn-secondary" @click="save">
              <i class="fa fa-save"></i> Salvar
            </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'realm',
  data() {
    return {
      model: {
        confId: 'foo',
        realm: {},
        configurations: [],
        user: {}
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (id !== undefined) {
      axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'realms/' + id).then(response => {
        this.model = response.data
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao carregar o realm.')
      })
    }
  },
  methods: {
    save: function () {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        var id = this.$route.params.id
        if (id !== undefined) {
          this.update(id)
        } else {
          this.insert()
        }
      }
    },
    insert: function () {
      axios.post(process.env.MYSTIQUE_MANAGER_API_URL + 'realms?associate_user=true', this.model)
        .then(response => {
          this.showSuccess('Realm criado com sucesso')
          this.$router.push('/mystique/realms')
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao salvar o realm.')
        })
    },
    update: function (id) {
      axios.put(process.env.MYSTIQUE_MANAGER_API_URL + 'realms/' + id, this.model)
        .then(response => {
          this.showSuccess('Realm alterado com sucesso')
          this.$router.push('/mystique/realms')
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao salvar o realm.')
        })
    },
    newTab: function () {
      this.model.configurations.push({
        name: '',
        databaseType: '',
        database: {}
      })
    },
    closeTab: function (index) {
      this.model.configurations.splice(index, 1)
    },
    changeDBType: function (database) {
      delete database.baseDn
      delete database.filter
      delete database.url
      delete database.user
      delete database.password
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?5f3df8da